export const DEFAULT_VIDEO_FORMAT = 'webm'
